import { Injectable } from "@angular/core";
import constantURL from '../../constantURL';
import { BaseLoggedInPostService } from '../../services/base-logged-in-post.service';

@Injectable({
  providedIn: "root"
})
export class ChangePasswordService extends BaseLoggedInPostService {
  _path = constantURL.auth.login.changePassword;



}
